// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width: 769px) {\n.modal-periodo-vigencia .columns[data-v-3b56247e] {\n    margin-bottom: 0;\n    margin-top: 0;\n}\n}", ""]);
// Exports
module.exports = exports;
